export default __webpack_public_path__ + "static/media/avatar3.bc800d55.png";